import LoginLayout from "../../shared/oversight-core/shared-components/login-layout/login-layout";
import RegistrationForm from "./registration-form/registration-form";

const Register = () => {
  return (
    <LoginLayout
      title="Sign UP"
      subTitle="Sing in to your account"
      showCarousel={true}
    >
      <RegistrationForm />
    </LoginLayout>
  );
};

export default Register;
